import { Component, OnDestroy, OnInit,ViewChild, ViewChildren, QueryList, ChangeDetectorRef, ElementRef, Input , Pipe, PipeTransform, Output, EventEmitter , ViewEncapsulation,AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup } from '@angular/forms';
import { interval } from 'rxjs';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';

import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ActivatedRoute, Router } from '@angular/router';

import { trigger, state, style, transition, animate , query, group, stagger } from '@angular/animations';
import { Location } from '@angular/common'

import { CustomerService } from '../../services/customer.service';
import { GlobalsService } from '../../services/globals.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { SpeechRecognitionService, SpeechRecognitionResult } from '../../services/speech-recognition.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-pos-customer-notes',
	templateUrl: './pos-customer-notes.component.html',
	styleUrls: ['./pos-customer-notes.component.scss'],
	animations: [
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: '0',width: '0' }),
				animate(200, style({ height: '*' , width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate(300, style({ height: 0, width: 0  })),
				animate('300ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class PosCustomerNotesComponent implements OnInit, OnChanges, OnDestroy {
	@Input() customer;
	@Input() saveNoteToDebtor = false;
	@Input() defaultNoteType = 'POS';
	@Output() editing = new EventEmitter<boolean>();
	@Output() newcustomerdata = new EventEmitter<boolean>();
	user: any = []
	noteFrom: UntypedFormGroup;
	notes: any = []
	newnote_id = 0;
	default_type ='POS';
	notetypes = ['POS'];
	removals: any = [];
	editingnote: any = false;
	customer_creation = false;
	
	// Voice recording properties
	isVoiceRecordingNote = false;
	currentVoiceNoteId: number | null = null;
	voiceSubscription: Subscription | null = null;
	voiceErrorSubscription: Subscription | null = null;
	voiceListeningSubscription: Subscription | null = null;
	confirmedVoiceText = ''; // Track confirmed text separately from interim results
	@ViewChildren('noteInput') noteInputs: QueryList<ElementRef<HTMLInputElement>>;
	sttDebug = true; // Toggle verbose speech-rec logs
	private finalizeCurrentInterim(): void {
		if (this.currentVoiceNoteId == null) { return; }
		const note = this.customer?.notes?.find((n: any) => n.noteid === this.currentVoiceNoteId);
		if (!note) { return; }
		// Persist only confirmed text to avoid leaving interim remnants behind
		note.note = this.confirmedVoiceText || '';
	}

	private focusNoteInput(noteId: number): void {
		if (!this.noteInputs) { return; }
		// Allow view to update first
		setTimeout(() => {
			const target = this.noteInputs.find(ref => ref?.nativeElement?.getAttribute('data-noteid') == String(noteId));
			if (target?.nativeElement) {
				target.nativeElement.focus();
				target.nativeElement.select();
			}
		}, 0);
	}

	private cleanupVoiceSubscriptionsOnly(): void {
		if (this.voiceSubscription) {
			this.voiceSubscription.unsubscribe();
			this.voiceSubscription = null;
		}
		if (this.voiceErrorSubscription) {
			this.voiceErrorSubscription.unsubscribe();
			this.voiceErrorSubscription = null;
		}
		if (this.voiceListeningSubscription) {
			this.voiceListeningSubscription.unsubscribe();
			this.voiceListeningSubscription = null;
		}
		this.speechRecognitionService?.stopListening();
		this.speechRecognitionService?.setContinuous(false);
	}

	constructor(private route: ActivatedRoute, private fb: UntypedFormBuilder, private customerService: CustomerService, public router: Router, private location: Location, private globalsService: GlobalsService, public globalSearchService: GlobalSearchService, private cdr: ChangeDetectorRef, public speechRecognitionService?: SpeechRecognitionService) {

	}
	ngOnChanges(changes: SimpleChanges): void {
		if(changes['saveNoteToDebtor'] && this.customer){
			//get notes hanging out
			const notes = this.customer.notes;
			//get debtorno from newly created cust & update notes with it
			this.customer = changes['saveNoteToDebtor'].currentValue.customer;
			notes.forEach(i => i.debtorno = this.customer.debtorno);
			this.customer.notes = notes;

			//save
			this.onSubmit();
		}
	}

	addNote() {

		this.editingnote = true;
		this.newnote_id = this.newnote_id - 1;
		const newNote ={
			debtorno: this.customer.debtorno,
			noteid: this.newnote_id,
			note: '',
			note_code: this.defaultNoteType,
		}
		if(!this.customer.notes){this.customer.notes = []}
		this.customer.notes.push(newNote);
	}

	updateNote(event:any, note: any) {
		const index = this.customer.notes.indexOf(note);
		this.customer.notes[index].note = event.target.value;
	}

	removeNote(id: any) {
		this.removals.push(id)
		this.customer.notes = this.customer.notes.filter( (note) => {
			return note.noteid != id;
		});
	}

	onSubmit() {

		// Only operate on POS notes in this component
		const allNotes = this.customer.notes || [];
		const posNotes = allNotes.filter((n: any) => n.note_code === 'POS');

		const emptyNoteIndexes: number[] = [];
		posNotes.forEach((note, index) => {
			if (((note.note || '') as string).trim() === '') {
				emptyNoteIndexes.push(index);
			}
		});

		if (emptyNoteIndexes.length > 0) {
			const remove = confirm(`The following notes are empty and will be removed:\n${emptyNoteIndexes.map(index => `- ${posNotes[index].note_code} ${posNotes[index].userid || ''} ${posNotes[index].notedate || ''}`).join('\n')}\n\nDo you want to proceed?`);

			if (remove) {
				// Move empty notes to the removals variable
				emptyNoteIndexes.forEach(index => {
					this.removals.push(posNotes[index].noteid);
				});
			} else {
				return;
			}
		}

		// Remove emptied POS notes from the working array
		const cleanedPosNotes = posNotes.filter((_, index) => !emptyNoteIndexes.includes(index));

		// Persist ONLY POS notes and removals triggered here
		this.customerService.updateDebtorNotes({ notes: cleanedPosNotes, removals: this.removals }).subscribe(
			(results) => {
				// Merge returned POS notes back into customer without touching other note types
				const otherNotes = (this.customer.notes || []).filter((n: any) => n.note_code !== 'POS');
				this.customer.notes = [...otherNotes, ...(results.notes || [])];
				this.newcustomerdata.emit(this.customer);
				this.editing.emit(false);
			},
			(error) => {
			}
		);
	}


	setForm() {

		this.newnote_id = this.newnote_id - 1;

		this.noteFrom = this.fb.group({
			debtorno: [this.customer.debtorno, Validators.required],
			noteid: [this.newnote_id, Validators.required],
			note: ['', Validators.required],
			note_code: [this.defaultNoteType, Validators.required],
		});
	}

	back(): void {
		this.editing.emit(false);
	}

	updateTopic(event:any, note:any) {
		note.note_code =event.value
	}

	get posNotes(): any[] {
		const notes = this.customer?.notes || [];
		return notes.filter((n: any) => n.note_code === 'POS');
	}

	// Voice recording methods
	toggleVoiceAddNote(): void {
		if (this.isVoiceRecordingNote) {
			this.stopVoiceRecording();
		} else {
			// Finalize any interim text on previous note before switching
			this.finalizeCurrentInterim();
			// Create a new note first
			this.addNote();
			// Get the note we just created
			const newNote = this.customer.notes[this.customer.notes.length - 1];
			this.currentVoiceNoteId = newNote.noteid;
			this.confirmedVoiceText = ''; // Always start a fresh session for new voice note
			this.startVoiceRecording();
		}
	}

	toggleVoiceEditNote(note: any): void {
		if (this.isVoiceRecordingNote && this.currentVoiceNoteId === note.noteid) {
			this.stopVoiceRecording();
		} else {
			// Finalize any interim on the previous target before switching
			this.finalizeCurrentInterim();
			this.currentVoiceNoteId = note.noteid;
			this.confirmedVoiceText = note.note || ''; // Start with existing note text
			this.startVoiceRecording();
		}
	}

	startVoiceRecording(): void {
		if (!this.speechRecognitionService?.getIsSupported()) {
			return;
		}

		// Clean up existing subscriptions/state, but keep currentVoiceNoteId intact
		this.cleanupVoiceSubscriptionsOnly();
		// Ensure any previous recognition session is fully aborted to avoid carryover
		this.speechRecognitionService?.abortListening();

		// Enable continuous mode and interim results for live typing
		this.speechRecognitionService.setContinuous(true);
		this.speechRecognitionService.setInterimResults(true);

		// Ensure we focus the target note input
		if (this.currentVoiceNoteId != null) {
			this.focusNoteInput(this.currentVoiceNoteId);
		}

		// Request microphone permission first, then wire subscriptions and start
		this.speechRecognitionService.requestMicrophonePermission().then((hasPermission) => {
			if (this.sttDebug) {
				console.log('[STT][Notes] Mic permission result:', { hasPermission, noteId: this.currentVoiceNoteId });
			}
			if (!hasPermission) {
				this.isVoiceRecordingNote = false;
				return;
			}

			// Subscribe to speech recognition results
			this.voiceSubscription = this.speechRecognitionService.result$.subscribe(
				(result: SpeechRecognitionResult | null) => {
					if (result && result.transcript.trim()) {
						const noteToUpdate = this.customer.notes.find((n: any) => n.noteid === this.currentVoiceNoteId);
						if (!noteToUpdate) {
							return;
						}

						if (this.sttDebug) {
							console.log('[STT][Notes] result', {
								noteId: this.currentVoiceNoteId,
								isFinal: result.isFinal,
								confidence: result.confidence,
								transcript: result.transcript
							});
						}

						if (result.isFinal) {
							// Final result - append confirmed text (speech naturally ended)
							const before = this.confirmedVoiceText;
							this.confirmedVoiceText = this.confirmedVoiceText ? 
								`${this.confirmedVoiceText} ${result.transcript.trim()}` : 
								result.transcript.trim();
							noteToUpdate.note = this.confirmedVoiceText;
							this.cdr.detectChanges();
							if (this.sttDebug) {
								console.log('[STT][Notes] final applied', { noteId: this.currentVoiceNoteId, before, after: this.confirmedVoiceText });
							}
							// Keep listening for more phrases (continuous mode)
						} else {
							// Interim result - show confirmed text + current interim (replace, don't append)
							const displayText = this.confirmedVoiceText ? 
								`${this.confirmedVoiceText} ${result.transcript.trim()}` : 
								result.transcript.trim();
							noteToUpdate.note = displayText;
							this.cdr.detectChanges();
							if (this.sttDebug) {
								console.log('[STT][Notes] interim applied', { noteId: this.currentVoiceNoteId, displayText });
							}
						}
					}
				}
			);

			// Subscribe to errors
			this.voiceErrorSubscription = this.speechRecognitionService.error$.subscribe(err => {
				if (err) {
					if (this.sttDebug) {
						console.error('[STT][Notes] error', err);
					}
					this.stopVoiceRecording();
				}
			});

			// Subscribe to listening state
			this.voiceListeningSubscription = this.speechRecognitionService.isListening$.subscribe(listening => {
				if (this.sttDebug) {
					console.log('[STT][Notes] listening state', { listening, noteId: this.currentVoiceNoteId });
				}
				this.isVoiceRecordingNote = listening && this.currentVoiceNoteId != null;
			});

			// Start listening
			this.speechRecognitionService.startListening().catch((error) => {
				console.error('Failed to start voice recording:', error);
				this.stopVoiceRecording();
			});
		});
	}

	stopVoiceRecording(): void {
		if (this.voiceSubscription) {
			this.voiceSubscription.unsubscribe();
			this.voiceSubscription = null;
		}
		if (this.voiceErrorSubscription) {
			this.voiceErrorSubscription.unsubscribe();
			this.voiceErrorSubscription = null;
		}
		if (this.voiceListeningSubscription) {
			this.voiceListeningSubscription.unsubscribe();
			this.voiceListeningSubscription = null;
		}
		this.speechRecognitionService?.stopListening();
		this.speechRecognitionService?.setContinuous(false); // Reset continuous mode
		this.isVoiceRecordingNote = false;
		this.currentVoiceNoteId = null;
		this.confirmedVoiceText = ''; // Clear confirmed text
	}

	ngOnInit(): void {
		//no customer being provided means it's coming from new customer creation
		if(this.customer == undefined || this.customer == ''){
			this.customer_creation = true;
			this.customer = [];
			this.customer.notes = [];
		}else{
			//customer provided means it's coming from pos order entry screen
			this.notes = this.customer.notes;
			if(!this.notes) {
				this.customer.notes = [];
				this.addNote();
			} else {
				// Ensure each existing note has a valid type; default missing types to POS in POS component
				this.customer.notes = (this.customer.notes || []).map((n: any) => {
					if (!n.note_code || this.notetypes.indexOf(n.note_code) === -1) {
						n.note_code = this.defaultNoteType;
					}
					return n;
				});
			}
		}

	}
	ngAfterViewInit() {
	}

	ngOnDestroy(): void {
		this.stopVoiceRecording();
	}
}
